module.exports = __webpack_public_path__ + "static/media/sloankettering.5a163d52.png";